import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from 'contexts/auth';
import { useHistory } from 'react-router';

import {
  Container,
  LeftBottom,
  LeftCenter,
  LeftTop,
  LogoWrapper,
  RepfyLogo,
  RightBottom,
  RightTop,
} from './_splashScreen';

export const SplashScreen: React.FC = () => {
  const history = useHistory();

  const { checkIfFirstTimeUsingApplication, accessToken } = useContext(AuthContext);

  useEffect(() => {
    triggerTimeout();
  }, []);

  const triggerTimeout = () => {
    setTimeout(() => {
      redirectToHomePage();
    }, 3600);
  };

  const redirectToHomePage = () => {
    if (accessToken) {
      return history.push('/home');
    } else {
      return checkIfFirstTimeUsingApplication()
        ? history.push('login')
        : history.push('demonstracao');
    }
  };

  return (
    <Container>
      <LeftTop />

      <LeftCenter />

      <LeftBottom />

      <LogoWrapper>
        <RepfyLogo />

        <h1>Prestadores</h1>
      </LogoWrapper>

      <RightTop />

      <RightBottom />
    </Container>
  );
};
